exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".section-signup-authenticate {\n  margin-top: 25px;\n  padding-top: 25px;\n  border-top: 1px solid #dee2e6;\n  text-align: center;\n}\n", ""]);

